// extracted by mini-css-extract-plugin
export default {"contactsPage":"Contacts_contactsPage__Vv-ZD"};